import { z } from 'zod';
import { parseEnv } from './utils/env/parseEnv';

const envRaw = {
  VITE_BFF_API_BASE_URL: import.meta.env.VITE_BFF_API_BASE_URL,
  VITE_BOOST_PLATFORM_API_BASE_URL: import.meta.env.VITE_BOOST_PLATFORM_API_BASE_URL,
  VITE_PRICE_OPTIMISATION_API_BASE_URL: import.meta.env.VITE_PRICE_OPTIMISATION_API_BASE_URL,
  VITE_PRICE_OPTIMISATION_GAME_PRICES_API_BASE_URL: import.meta.env.VITE_PRICE_OPTIMISATION_GAME_PRICES_API_BASE_URL,
  VITE_ANALYTICS_ENABLED: import.meta.env.VITE_ANALYTICS_ENABLED,
  VITE_MIXPANEL_PROJECT_KEY: import.meta.env.VITE_MIXPANEL_PROJECT_KEY,
  /** Overrides from /public/env.js */
  // @ts-expect-error
  ...globalThis.env,
};

// This may move to a specific workspace package, `env`, to create one
// central env schema and parsing function.
const envSchema = z.object({
  VITE_BOOST_PLATFORM_API_BASE_URL: z.string(),
  VITE_PRICE_OPTIMISATION_API_BASE_URL: z.string(),
  VITE_PRICE_OPTIMISATION_GAME_PRICES_API_BASE_URL: z.string(),
  VITE_ANALYTICS_ENABLED: z.string(),
  VITE_MIXPANEL_PROJECT_KEY: z.string(),
  VITE_BFF_API_BASE_URL: z.string(),
});

/** Use this object to access all client env variables, rather than using `import.meta.env.*`. */
export const appEnv = parseEnv(envRaw, envSchema) as z.infer<typeof envSchema>;
